<template>
  <div>
    <div class="goods-list">
      <div v-if="zhanwei" class="zhanwei">
        <img src="@/assets/zhanweitu.png" alt />
      </div>
      <template v-else>
        <div class="goods-type-list" v-for="(item,itemIdx) in filterData" :key="itemIdx">
          <div class="goods-hint" v-if="item.goods.length == 0">此分类下暂无商品！</div>
          <div class="goods-title" v-else>{{item.title}}</div>
          <template v-if="item.goods.length !== 0">
            <div
              class="goods-info"
              v-for="(good,goodIdx) in item.goods"
              :key="goodIdx"
              @click="jumpF(good.id, mobile)"
            >
              <div class="info-left">
                <img :src="$root.tomedia(good.thumb)" />
                <span style="width:440px">{{good.title}}</span>
              </div>
              <div
                class="info-center"
              >{{ good.type == 0 ? "自动发货" : good.is_api == 1 && good.type == 1 ? "自动充值" : good.is_api == 1 && good.type == 5 ? "自动充值" : good.is_api == 0 && good.type == 1 ? "商家代充" : ""}}</div>
              <div class="info-right">
                <div>
                  <div>￥{{good.price}}</div>
                  <div>库存：{{good.stock}}</div>
                </div>
                <el-button type="primary" size="small">购买</el-button>
              </div>
            </div>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import getData from '@/utils/getData'
import { getUrlUserInfo } from '@/common/common' // 获取url的参数

export default {
  data() {
    return {
      urlQueryName: null,
    }
  },
  props: {
    category: {
      type: Array,
      required: false,
    },
    mobile: {
      type: String,
      required: false,
    },
    categoryId: {
      type: String,
      required: false,
    },
    zhanwei: {
      type: Boolean,
      required: false,
    },
  },
  components: {},
  computed: {
    filterData() {
      if (this.categoryId) {
        return this.category.filter((item) => {
          return item.id == this.categoryId
        })
      } else {
        return this.category.filter((item) => {
          return item.goods.length > 0
        })
      }
    },
  },
  watch: {},
  methods: {
    async getStyle() {
      let name = await getUrlUserInfo(this.$route.fullPath) // sup 或者 mid
      this.urlQueryName = name
      let style = await getData.getShopStyle(name, this.$route.query[name])
    },
    jumpF(id, mobile) {
      this.$router.push({
        path: 'order',
        query: {
          [this.urlQueryName]: this.$route.query[this.urlQueryName],
          id,
          mobile,
        },
      })
    },
  },
  created() {
    this.getStyle()
  },
  mounted() {},
  updated() {},
  destroyed() {},
  filters: {},
}
</script>

<style scoped lang="less">
@import '../../common/Less/index';
.goods-list {
  flex: 1;
  overflow: auto;
  overflow-x: hidden;
  // min-height: 500px;
  .goods-title {
    padding-left: 30px;
    line-height: 30px;
    font-size: 16px;
    margin-top: 10px;
  }
  .goods-hint {
    padding: 10px 20px;
    margin: 10px;
  }
  .goods-info {
    padding: 10px 20px;
    margin: 10px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    .info-left {
      display: flex;
      align-items: center;
      width: 70%;
      img {
        width: 80px;
        height: 80px;
        margin-right: 30px;
      }
    }
    .info-center {
      align-items: center;
      display: flex;
      flex: 1;
      color: #2a9aec;
    }
    .info-right {
      display: flex;
      align-items: center;
      > div {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 30px;
      }
      /deep/ .el-button--primary {
        background: #ffa662;
        border: none;
      }
    }
  }
  .zhanwei {
    padding: 20px auto;
    text-align: center;
    background: #fff;
  }
  // .goods-info:hover {
  //   background-color: #ffe4dc;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/Shop/ShopList2.vue